import React from 'react'
import PropTypes from 'prop-types'
import CourseMenuCourseLink from './CourseMenuCourseLink'
import { decodeHtml } from '../../utils'

const CourseMenuItem = React.forwardRef((props, ref) => {
  return (
    <React.Fragment>
      <li
        ref={ref}
        className="ReaderNavItemBlue CourseNavMenuItem me-list-item pl-4"
        role="menuitem"
        tabIndex="0"
      >
        {
          <CourseMenuCourseLink
            title={decodeHtml(props.itemTitle)}
            cnum={props.coursenum}
            archived={props.archived}
            role={props.role}
          />
        }
      </li>
    </React.Fragment>
  )
})

CourseMenuItem.displayName = 'CourseMenuItem'

CourseMenuItem.propTypes = {
  itemTitle: PropTypes.string,
  role: PropTypes.string,
  coursenum: PropTypes.string,
  signup: PropTypes.bool,
  archived: PropTypes.bool,
}

export default CourseMenuItem
